<template>
  <div class="tables-basic">
    <div v-if="loading" class="page-loading-container">
      <b-spinner label="Loading..." ></b-spinner>
    </div>
    <div v-else>

      <h2 class="page-title">My Account</h2>
      <b-row >
        <b-col>
          <Widget
          >
            <b>Email:</b> {{user.email}}
          </Widget>
        </b-col>
      </b-row>
      <b-row >
        <b-col>
          <Widget title="Subscription"
          >
            <b>Plan:</b> {{user.websites_subscription.websites_plan.display_name}}
            <p>
            <b>Tests Remaining: </b>  {{user.available_audits}}
            <p></p>
            <demo-notice :show="!!$route.query.purchase" :initiatePurchase="$route.query.purchase" button="Change Plan"></demo-notice>
          </Widget>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import Widget from '@/components/Widget/Widget';
  import DemoNotice from "@/components/DemoNotice/DemoNotice";

  import { mapState } from 'vuex';
  import axios from "axios";
  export default {
    name: 'Tables',
    components: { Widget, DemoNotice },
    data() {
      return {
        toastOptions: {
          theme: 'dark',
          position: 'bottomLeft',
        },
        loading: false,
      };
    },
    computed: {
      ...mapState({activeSite: 'activeSite', user: 'user'}),
    },
    metaInfo: {
      title: 'My Account - PageWatch.dev',
    },
    methods: {
      deleteSite(site){
        const h = this.$createElement;
        const titleVNode = h('div', {domProps: {innerHTML: `This will delete the site and all historical data<br>Are you sure you want to continue?.`}});
        this.$bvModal.msgBoxConfirm([titleVNode], {
          title: 'Delete Site',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Delete Site',
          cancelTitle: 'Cancel',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
                .then(ok => {
                  if (ok) {
                    axios
                            .delete(`websites/update/${site.uuid}`)
                            .then(
                                    response => {
                                      this.$root.$emit("websites-reload");
                                      return true;

                                    },
                                    _response => {
                                      console.warn(_response);
                                      return false;
                                    }
                            );
                  }
                })






      },
      selectSite(site){

        axios
                .put(`websites/active/${site.uuid}`)
                .then(
                        response => {
                          // this.$store.commit("setActiveSite", site);
                          this.$router.push({ name: "Dashboard" });
                          return true;
                        },
                        _response => {
                          console.warn(_response);
                          return false;
                        }
                );

      },
      cancelSubscription(website) {
        const h = this.$createElement;
        const titleVNode = h('div', {domProps: {innerHTML: `<div class="alert alert-danger" role="alert">This will stop the automatic audits for this website.</div>`}});
        this.$bvModal.msgBoxConfirm([titleVNode], {
          title: 'Cancel recurring audits',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: 'Stop Subscription',
          cancelTitle: 'Cancel',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
                .then(ok => {
                  if (ok) {

                    axios
                            .put(`websites/cancel/${website.uuid}`)
                            .then(
                                    response => {
                                      website.recurring = false
                                      return true;
                                    },
                                    _response => {
                                      alert('We were not able to stop the subscription, please contact support')
                                      return false;
                                    }
                            );

                  }
                })

      }

    },
    created() {
      this.$watch("$route",() => { this.currentPage = this.$route.query.page || 1}, {
        immediate: true
      });
    },
    mounted(){
      if (this.user.role !== 'user'){
        this.$router.push({ name: "Dashboard" });
      }
    }
  };
</script>

<style src="./Websites.scss" lang="scss" scoped />
<style lang="scss">
  .link-redirect {
    font-size:9pt;
    color:gray;
    padding:4px;
  }
  .link-status-redirect{
    color:red;
    font-size:9pt;
    padding:4px;
  }
  .link-entry{
    max-width:580px;
    overflow:auto;
  }
  .broken-link-preview-image {
    border-radius: 50%;
    max-width: 250px;
    box-shadow: #bdc4e0 0px 0px 20px;
  }
</style>
